import { useEffect, useState } from 'react';
import { Dialog, DialogClose, DialogContent, DialogFooter } from 'src/components/ui/dialog';
import { useAppSelector, useAppDispatch } from 'src/store';
import { setOpenFinalPopup } from 'src/store/slices/integrationSlice';
import { Button } from 'src/components/ui/button';

export const IntegrationFinalPopup = () => {
  const [open, setOpen] = useState(false);
  const { selectedIntegration, openFinalPopup } = useAppSelector((s) => s.integrationSlices);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (openFinalPopup && selectedIntegration?.setupGuideUrl) {
      setOpen(true);
    }
  }, [openFinalPopup, selectedIntegration]);

  const onOpenChange = (open: boolean) => {
    if (!open) {
      dispatch(setOpenFinalPopup(false));
    }

    setOpen(open);
  };

  return selectedIntegration ? (
    <Dialog closeButtonHidden onOpenChange={onOpenChange} open={open}>
      <DialogContent
        closeButtonHidden
        className="pb-10 pt-12 px-16 items-center justify-center gap-10 outline-0"
      >
        <div className="grid gap-4 max-w-[400px]">
          <div className={'flex w-full items-center justify-center'}>
            <h2 className={'text-lg font-bold text-ebony_opacity_80 text-center'}>
              All set! Check{' '}
              <a
                href={selectedIntegration.setupGuideUrl}
                target={'_blank'}
                rel="noopener noreferrer"
                className={'text-[#7A6BE5] hover:underline'}
              >
                this guide
              </a>{' '}
              to review <br />
              advanced customization settings.
            </h2>
          </div>
        </div>
        <DialogFooter className="w-full !justify-center max-md:flex-row">
          <DialogClose asChild>
            <Button
              variant="outline"
              className="flex items-center gap-1 min-w-[100px] shadow-[0_2px_2px_0_rgba(0,0,0,0.25)]"
            >
              <p className="font-semibold text-sm font-jamjuree">Got it</p>
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  ) : null;
};
